import { format, parseISO } from 'date-fns';
import { toast } from 'react-toastify';

export const toCurrency = (value, maxDigits = 2) => {
  if (value === undefined || value === null) {
    return 'N/A';
  }

  try {
    const formatter = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      maximumFractionDigits: maxDigits,
    });

    return formatter.format(value);
  } catch (e) {
    toast.error(`${value} is an invalid currency format`);
  }
};

export const toFormattedDate = (dateStr, formatStr = 'yyyy-MM-dd') => {
  if (!dateStr) {
    return '';
  }
  try {
    const date = parseISO(dateStr);
    return format(date, formatStr);
  } catch (e) {
    toast.error(`${dateStr} is an invalid date format`);
  }
};

export const formatDate = (dateStr, formatStr = 'yyyy-MM-dd') => {
  if (!dateStr) {
    return '';
  }
  try {
    return format(dateStr, formatStr);
  } catch (e) {
    toast.error(`${dateStr} is an invalid date format`);
  }
};

export const toFormattedRate = (rate) => {
  return `${rate * 100}%`;
};

export const formatCustomerName = (customer) => {
  let result = '';
  if (customer.title) {
    result += customer.title + ' ';
  }
  if (customer.givenName) {
    result += customer.givenName + ' ';
  }
  if (customer.middleName) {
    result += customer.middleName + ' ';
  }
  if (customer.familyName) {
    result += customer.familyName + ' ';
  }
  if (customer.suffix) {
    result += customer.suffix + ' ';
  }
  return result;
};

export const toFormattedDateTime = (dateStr, formatStr = 'yyyy-MM-dd HH:mm:ss') => {
  if (!dateStr) {
    return '';
  }

  try {
    const date = parseISO(dateStr);
    return format(date, formatStr);
  } catch (e) {
    toast.error(`${dateStr} is an invalid date format`);
  }
};

export const toPercentage = (num) => {
  if (!num) {
    return '';
  }
  try {
    return Number(num).toLocaleString(undefined, { style: 'percent', minimumFractionDigits: 2 });
  } catch (e) {
    toast.error(`${num} is an invalid percentage format`);
  }
};


export const wordFromCamelCase = (camelCase: string) => {
  return camelCase.replace(/([A-Z])/g, ' $1').replace(/^./, function(str){ return str.toUpperCase(); });
} 

export const toCommaSeperatedString = (arr: string[]) => {
    
  if (!arr || arr.length === 0) {      
      return '';
    }    
  return arr.join(', ');
}


